import { render, staticRenderFns } from "./Solicitarsaque.vue?vue&type=template&id=0712b491&scoped=true"
import script from "./Solicitarsaque.vue?vue&type=script&lang=js"
export * from "./Solicitarsaque.vue?vue&type=script&lang=js"
import style0 from "./Solicitarsaque.vue?vue&type=style&index=0&id=0712b491&prod&lang=css"
import style1 from "./Solicitarsaque.vue?vue&type=style&index=1&id=0712b491&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0712b491",
  null
  
)

export default component.exports